/* eslint-disable no-console */
/** biome-ignore-all lint/suspicious/noConsole: This is the centralized place for all permanent logging in the platform */

import { captureException } from '@sentry/react'

export function logConsoleError(error: unknown) {
  console.error(error)
}

export function logError<T extends Error>(error: T) {
  logConsoleError(error)
  captureException(error)
}

export function logWarning(warning: string) {
  console.warn(warning)
}
